"use client";
import { MyLoans } from "../../components/borrow/my-loans";
import React, { useMemo } from "react";
import { MySupportedNfts } from "../../components/borrow/nft-admitted";
import { useRouter } from "next/navigation";
import { Loan } from "../../logic/types/loan/Loan";
import { INft } from "logic/types/nft/INft";
import { useGetNfts } from "logic/hooks/borrow";
import { useChain } from "components/providers/ChainProvider";
import Chain from "logic/types/chain/Chain";

export default function BorrowFlow(): JSX.Element {
  const router = useRouter();
  const { chainId } = useChain();
  const handleDepositClick = () =>
    router.push(`/borrow/create-loan/${Chain.get(chainId).name}`);
  const handleBorrowClick = () =>
    router.push(`/borrow/create-loan/${Chain.get(chainId).name}`);
  const { handleRemoveNfts, isLoading, nfts, handleUnlockedNfts } = useGetNfts({
    activeFilters: {
      assetOrigin: false,
      categories: false,
      collection: false,
      currency: false,
      order: false,
    },
    avoidDeposited: false,
  });

  const availableNfts = useMemo<INft[]>(
    () => [...nfts.filter((nft) => !nft.isDeposited)],
    [nfts]
  );

  const handleFullyRepay = (loan: Loan) => {
    handleUnlockedNfts(loan.nfts);
  };

  const handleNftSold = (nft: INft) => {
    handleRemoveNfts([nft]);
  };

  return (
    <>
      <MySupportedNfts
        nfts={nfts}
        isLoading={isLoading}
        onDepositClick={handleDepositClick}
        onBorrowClick={handleBorrowClick}
      />
      <MyLoans
        className="mb-8"
        availableNfts={availableNfts}
        onFullyRepaid={handleFullyRepay}
        onNftSold={handleNftSold}
      />
    </>
  );
}
